module.exports = __webpack_public_path__ + "static/media/chanel-bleu-de-chanel-big.6d1d2072.png";